import { ContactListModel } from 'api/dto/ContactList.dto';
import { Resource } from 'model/Resource';

export const STORE_NAME = 'contactList';

export namespace ContactListState {
  export type ContactListResource = Resource<ContactListModel | null>;
  export type Domain = {
    contactList: ContactListResource;
  };

  export const INITIAL_DOMAIN: Domain = {
    contactList: Resource.createPendingResource<ContactListModel>(),
  };
}
